import { FC } from 'react'
import { useSetRecoilState } from 'recoil'
import styled from 'styled-components'
import { isInViewFooterState, stepState } from '../../../states/messageState'
import { useInViewFooter } from '../../../hooks/useInViewFooter'
import { useSendMessage } from '../../../hooks/useSendMessage'
import { useCheckEmail } from '../../../hooks/useCheckEmail'
//components
import { FooterContent } from '../FooterContent'
import { Button } from '../../Button'

export const ChooseNaturalFailure: FC = () => {
  const { handleInViewFooter } = useInViewFooter()
  const { handleAddSenderParent } = useSendMessage()
  const { checkEmail } = useCheckEmail()

  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)
  const setCurrentStep = useSetRecoilState(stepState)

  /**自然故障を選択 */
  const handleSubmitNaturalFailure = async (isNaturalFailure: boolean) => {
    setIsInViewFooter(false)
    await handleAddSenderParent('user', isNaturalFailure ? 'はい' : 'いいえ')
    if (isNaturalFailure) {
      checkEmail()
    } else {
      await handleAddSenderParent(
        'bot',
        '大変申し訳ございません。保証対象は自然故障となっている為ご対応が出来ません。\nさらなるお問い合わせが必要な場合はcustomer@helloproteger.comか0570-081170(受付時間：平日 月〜金 10:00~18:00)へお問い合わせ下さい。'
      )
      handleInViewFooter()
      setCurrentStep('notFoundInquiryCodeOrEmail')
    }
  }

  return (
    <FooterContent isWide={false}>
      <FlexWrap>
        <Button buttonType="outlined" onClick={() => handleSubmitNaturalFailure(false)}>
          いいえ
        </Button>
        <Space size={20} />
        <Button buttonType="outlined" onClick={() => handleSubmitNaturalFailure(true)}>
          はい
        </Button>
      </FlexWrap>
    </FooterContent>
  )
}

const FlexWrap = styled.div`
  display: flex;
`
const Space = styled.div<{ size: number }>`
  width: ${({ size }) => `${size}px`};
  height: 1px;
`
